import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import * as yup from "yup";
import { isEmpty, isNotEmpty } from "../Utils";
import { getFormId } from "../redux/selector";

const hkidCheckMap = {
    0: 0,
    1: 1,
    2: 2,
    3: 3,
    4: 4,
    5: 5,
    6: 6,
    7: 7,
    8: 8,
    9: 9,
    A: 10,
    B: 11,
    C: 12,
    D: 13,
    E: 14,
    F: 15,
    G: 16,
    H: 17,
    I: 18,
    J: 19,
    K: 20,
    L: 21,
    M: 22,
    N: 23,
    O: 24,
    P: 25,
    Q: 26,
    R: 27,
    S: 28,
    T: 29,
    U: 30,
    V: 31,
    W: 32,
    X: 33,
    Y: 34,
    Z: 35,
};

export default function useCustomYup(requiredMsg) {
    const { t } = useTranslation();
    const formId = useSelector(getFormId());

    return {
        hkidYup: yup
            .string()
            .test(
                "IS require",
                requiredMsg || t("errorMsg.required"),
                (value) => {
                    if (isEmpty(value)) return false;
                    let [main, checkDigit] = value.split("(");
                    checkDigit = checkDigit.split(")")[0];
                    return isNotEmpty(main) && isNotEmpty(checkDigit);
                }
            )
            .test(
                "hkid rules",
                formId === "Form101"
                    ? t("Form101.errorMsg.hkidValid")
                    : t("errorMsg.hkid.rule"),
                (value) => {
                    if (isEmpty(value)) {
                        return false;
                    }
                    let [main, checkDigit] = value.split("(");
                    checkDigit = checkDigit.split(")")[0];
                    //we will not check if the digit either is a letter or a number. Therefore, it is important to use <CustomHKID> as the input since it will do that part.
                    if (
                        isNotEmpty(main) &&
                        isNotEmpty(checkDigit) &&
                        main.length > 0 &&
                        checkDigit.length == 1
                    ) {
                        let sum = 0;
                        if (main.length == 7) {
                            sum = main
                                .split("")
                                .reduce(
                                    (accumulator, currentValue, index) =>
                                        accumulator +
                                        hkidCheckMap[currentValue] *
                                            (8 - index),
                                    36 * 9
                                );
                        } else if (main.length == 8) {
                            sum = main
                                .split("")
                                .reduce(
                                    (accumulator, currentValue, index) =>
                                        accumulator +
                                        hkidCheckMap[currentValue] *
                                            (9 - index),
                                    0
                                );
                        } else {
                            return false;
                        }
                        const result = 11 - (sum % 11);
                        return (
                            (result === 11 && checkDigit == "0") ||
                            hkidCheckMap[checkDigit] === 11 - (sum % 11)
                        );
                    } else {
                        return false;
                        // if (!(isNotEmpty(main) && isNotEmpty(checkDigit))) {
                        //     return true;
                        // } else {
                        //     return false;
                        // }
                    }
                }
            ),
        hkidNotRequiedYup: yup
            .string()
            .test(
                "hkid rules",
                formId === "Form101"
                    ? t("Form101.errorMsg.hkidValid")
                    : t("errorMsg.hkid.rule"),
                (value) => {
                    if (isEmpty(value)) {
                        return true;
                    }
                    let [main, checkDigit] = value.split("(");
                    checkDigit = checkDigit.split(")")[0];
                    if (isEmpty(main) && isEmpty(checkDigit)) {
                        return true;
                    }
                    //we will not check if the digit either is a letter or a number. Therefore, it is important to use <CustomHKID> as the input since it will do that part.
                    if (
                        isNotEmpty(main) &&
                        isNotEmpty(checkDigit) &&
                        main.length > 0 &&
                        checkDigit.length == 1
                    ) {
                        let sum = 0;
                        if (main.length == 7) {
                            sum = main
                                .split("")
                                .reduce(
                                    (accumulator, currentValue, index) =>
                                        accumulator +
                                        hkidCheckMap[currentValue] *
                                            (8 - index),
                                    36 * 9
                                );
                        } else if (main.length == 8) {
                            sum = main
                                .split("")
                                .reduce(
                                    (accumulator, currentValue, index) =>
                                        accumulator +
                                        hkidCheckMap[currentValue] *
                                            (9 - index),
                                    0
                                );
                        } else {
                            return false;
                        }
                        const result = 11 - (sum % 11);
                        return (
                            (result === 11 && checkDigit == "0") ||
                            hkidCheckMap[checkDigit] === 11 - (sum % 11)
                        );
                    } else {
                        return false;
                    }
                }
            ),
    };
}
